import React from 'react'
import CommonHeader from './common/CommonHeader'
import '../torfacts.css'
import Footer from './common/Footer'
import KnowMore from './common/KnowMore';


const TermsAndConditions = () => {
  return (
    <>
      <div className="main-content">
        <CommonHeader title={'Terms And Conditions'} stitle={" The use of this website is subject to the following terms of use."} id={'3'} />

      </div>
      <div className='pageContent bg-light-blue'>
        <div className="main-content">
          <div className='question-box'>
            <h2 className='question-title'>When you register</h2>
            <p className='page-content'>When you create a personal account, we ask you some personal information,
              as mentioned here:</p>
            <ul className='key-points'>
              <li>You can update or change your Basic profile information at any time</li>
              <li>You can opt-out or close your account at any time.</li>
              <li>We respect your privacy and make best use of technology to safe guard your information from unauthorized physical and electronic access.</li>
              <li>We share your information only with organizations, which are required to operate Torfac. And those organizations need to take care of our commitments to your privacy and security.</li>
            </ul>
          </div>

          <div className='question-box'>
            <h2 className='question-title'>What information we collect from you</h2>
            <p className='page-content'>Directly collected</p>
            <ul className='key-points'>
              <li>Email address and password of your account with us.</li>
              <li>Your response to profiling questions.</li>
              <li>Any customer service correspondence.</li>
              <li>Any personal details you share for redemption</li>
              <li>Any other information directly provided by you.</li>
            </ul>
            <p className='page-content'>Usage data</p>
            <ul className='key-points'>
              <li>Your IP address, geo location and cookies</li>
              <li>Information about the device you use</li>
              <li>Your survey activity, points in your account, the payments you receive after redeeming.</li>
              
            </ul>
          </div>

        <div className='question-box'>
            <h2 className='question-title'>How do we use your data</h2>
            
            <ul className='key-points'>
              <li>Sending you invitation emails to take up the survey you qualify for.</li>
              <li>Detect and prevent fraudulent activity.</li>
              <li>Improve your experience on Torfac platform.</li>
              <li>Your responses are transferred to our affiliated third parties and partners in an aggregated and de-identified format.</li>
              <li>Our partners can ask you to provide your name, email address and other contact information during a survey.</li>
            
              <li>You are free to decline providing your details to our partners, if you agree than you are providing this information directly to them and not to Torfac.</li>
              <li>Your information will be dealt with in accordance with the relevant business Privacy Policy and not Torfac’s Privacy Policy.</li>
              <li>Our partners are committed to respect and protect your privacy.</li>
              
            </ul>
          </div>

          <div className='question-box'>
            <h2 className='question-title'>What we don’t do with it</h2>
            
            <ul className='key-points'>
              <li>We don’t sell on that information to anyone, and we don’t use it to sell anything to you. We will always ask permission before sharing your data.</li>             
            </ul>
          </div>

          <div className='question-box'>
            <h2 className='question-title'>Your right to control your data</h2>
            
            <ul className='key-points'>
              <li>You have full control of your data.</li>
              <li>You can access, update or change your basic profile information whenever you want.</li>
              <li>You can unsubscribe and deactivate your account.</li>
              <li>You are free to get your profile deleted by sending us a mail at support@torfacts.com. We would try to resolve your concern and if you still wish to get your account deleted, then shall be doing it within 72 hours.</li>
            </ul>
          </div>

          <div className='question-box'>
            <h2 className='question-title'>Data Security</h2>
            <p>Our tech team works really hard to keep all your data secure.</p>
            <p>We make use of latest technology and measures to avoid any misuse or unauthorized access of your data. However, due to the nature of the online environment we cannot give 100% assurance of data security.</p>
            <p>We try our best to rule out the risks, however cannot guarantee risk free environment. By accepting these Terms and Condition, you acknowledge and accept these risks.</p>            
          </div>

          <div className='question-box'>
            <h2 className='question-title'>Any questions, please feel free to contact us</h2>
            <p>If you have any queries or complaints about our privacy policy and procedures. Please send us an email at <b>support@torfacts.com</b> and we shall get back to you within 48 hours.</p>            
          </div>

        </div>
      </div>
      <KnowMore />
      <Footer />
    </>
  )
}

export default TermsAndConditions